import * as React from 'react'
const FloatingButtonIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="23px"
    viewBox="0 0 24 23"
    {...props}
  >
    <g id="surface1">
      <path
        style={{
          fill: 'none',
          strokeWidth: 2,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: 'rgb(0%,0%,0%)',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        d="M 8.658854 31.363451 L 8.658854 23.970958 L 3.554688 23.970958 C 2.87679 23.970958 2.227376 23.701936 1.748861 23.219939 C 1.270345 22.743546 1.002604 22.09341 1.002604 21.415251 L 1.002604 3.553329 C 1.002604 2.87517 1.270345 2.225034 1.748861 1.748641 C 2.227376 1.266644 2.87679 0.997622 3.554688 0.997622 L 31.627604 0.997622 C 32.305501 0.997622 32.954915 1.266644 33.433431 1.748641 C 33.911947 2.225034 34.179688 2.87517 34.179688 3.553329 L 34.179688 21.415251 C 34.179688 22.09341 33.911947 22.743546 33.433431 23.219939 C 32.954915 23.701936 32.305501 23.970958 31.627604 23.970958 L 17.591146 23.970958 L 9.746908 31.811821 C 9.655762 31.901495 9.541829 31.963145 9.422201 31.985564 C 9.296875 32.013587 9.165853 32.002378 9.051921 31.951936 C 8.932292 31.901495 8.835449 31.82303 8.761393 31.716542 C 8.693034 31.610054 8.658854 31.486753 8.658854 31.363451 Z M 8.658854 31.363451 "
        transform="matrix(0.685714,0,0,0.69697,0,0)"
      />
      <path
        style={{
          fill: 'none',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'miter',
          stroke: 'rgb(0%,0%,0%)',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        d="M 8.658854 16.315048 L 26.523438 16.315048 M 8.658854 8.659137 L 26.523438 8.659137 "
        transform="matrix(0.685714,0,0,0.69697,0,0)"
      />
    </g>
  </svg>
)
export default FloatingButtonIcon
